import React from 'react';
import './PolicyPage.css';
import Footer from './Footer';
import ContactHome from './ContactHome';

const Security = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Security Policy</h1>
        <div className="policy-content">
          <section>
            <h2>1. Data Protection</h2>
            <p>
              At Fractallogy, we take the security of your data seriously. We implement industry-standard 
              security measures to protect your information from unauthorized access, alteration, disclosure, 
              or destruction.
            </p>
          </section>

          <section>
            <h2>2. Encryption</h2>
            <p>
              All data transmitted between your device and our servers is encrypted using SSL/TLS protocols. 
              We use strong encryption algorithms to ensure that your sensitive information remains secure 
              during transmission.
            </p>
          </section>

          <section>
            <h2>3. Access Controls</h2>
            <p>
              We employ strict access controls to ensure that only authorized personnel can access your data. 
              All access is logged and monitored for security purposes.
            </p>
          </section>

          <section>
            <h2>4. Regular Security Audits</h2>
            <p>
              We conduct regular security audits and vulnerability assessments to identify and address 
              potential security risks. Our systems are continuously monitored for suspicious activities.
            </p>
          </section>

          <section>
            <h2>5. Incident Response</h2>
            <p>
              In the event of a security breach, we have a comprehensive incident response plan in place. 
              We will notify affected users promptly and take immediate action to mitigate any potential damage.
            </p>
          </section>

          <section>
            <h2>6. Compliance</h2>
            <p>
              We comply with relevant data protection regulations and industry standards to ensure the 
              highest level of security for your information.
            </p>
          </section>

          <section>
            <h2>Contact</h2>
            <p>
              If you have any questions or concerns about our security practices, please{' '}
              <button 
                className="policy-email-link"
                onClick={() => window.dispatchEvent(new CustomEvent('openContactForm'))}
              >
                contact us
              </button>.
            </p>
          </section>
        </div>
      </div>
      <ContactHome />
      <Footer />
    </div>
  );
};

export default Security;
